import { withAxios } from "op/components/auth";
import { withLocale } from "op/components/locale";
import { withOnlineStatus } from "op/components/offline";
import { withReportSignatures } from "op/components/report/signature/report-signature.helper";
import SignatureModal from "op/components/report/signature/signature-modal/signature-modal.component";
import React, { useEffect, useMemo, useState } from "react";
import ReactDatePicker from "react-datepicker";
import FailedRemarkModal from "../failed-remark-modal/failed-remark-modal.component";
import { Icon, Message } from 'semantic-ui-react';
import { hot } from "react-hot-loader";
import { compose, withHandlers, withState } from "recompose";
import {
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Form,
  FormField,
  Header,
  Input,
  Loader,
  Select,
  Table,
  TextArea,
} from "semantic-ui-react";
import styled from "styled-components";
import FormSubmitModal from "../submit-modal/submit-modal.component";
import { useHistory } from "react-router";
import getDateTimeString from "op/utils/getDateTimeString";
import "react-datepicker/dist/react-datepicker.css";

const BoldText = styled.p`
  font-weight: bold;
  width: fit-content;
  display: inline-block;
  margin: 0;
  font-size: 1.2rem;
`;

const OverallStatusButtonsContainer = styled.div`
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 10px;
`;

const OverallStatusButton = styled.button`
  height: 3em;
  border: none;
  flex: ${(props) => (props.fluid ? 1 : 0)};
  border-radius: ${(props) => (props.rounded ? "5px" : "none")};
  color: ${(props) => (props.selected ? props.theme.white : props.theme.text)};
  background-color: ${(props) =>
    props.selected ? (props.pass ? "#21ba45" : "#db2828") : props.theme.white};
  outline: none !important;
  margin: 0 1.5px;
  cursor: pointer;
`;

const CardForSignature = styled(Card)`
  :first-child {
    border: solid 2px blue !important;
  }
`;

const ThreeStateInput = ({ value, onChange, locale, setIsOpenRemarkModal, chosenFormTypeObject, systemSettings }) => {
  return (
    <div style={{ display: "flex", gap: "1rem" }}>
      <ButtonGroup>
        <Button
          active={value === true}
          onClick={() => {
            onChange(true)
            if (chosenFormTypeObject && chosenFormTypeObject.asM_FormTypeMustFillKPIRemarks) {
              setIsOpenRemarkModal(true)
            }
          }}
          color={value === true ? "green" : undefined}
        >
          {locale.yes}
        </Button>
        <Button
          active={value === false}
          onClick={() => {
            onChange(false)
            if (systemSettings.isMaintRemarkForFailKPI) {
              setIsOpenRemarkModal(true)
            }
          }}
          color={value === false ? "red" : undefined}
        >
          {locale.no}
        </Button>
      </ButtonGroup>
      <Button
        active={value === null}
        onClick={() => {
          onChange(null)
          setIsOpenRemarkModal(false)
        }}
        color={value === null ? "blue" : undefined}
      >
        {locale.notApplicable}
      </Button>
    </div>
  );
};

const StyledIcon = styled(Icon)`
  width: 15.75px !important;
  height: 14.4px !important;
  font-size: 15.75px !important;
  line-height: 14.4px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
`;

const ExclamationIcon = ({ color = "red" }) => {
  return <StyledIcon name="exclamation circle" color={color} />;
};

const FormComponent = ({
  user,
  formTypes,
  fetchFormsTypes,
  fetchingFormTypes,
  locale,
  formTypeLines,
  fetchFormTypeLines,
  fetchingFormTypeLines,
  report,
  online,
  registerSignatrue,
  saveSignatrues,
  form,
  setForm,
  onSubmit,
  hasNoAnswers,
  overallStatus,
  fetchMaintAlertForFailKPI,
  isMaintAlertForFailKPI,
  systemSettings,
  fetchSystemSettings,
  setIsMandatoryRemarkForFailKPI,
  isMandatoryRemarkForFailKPI,
  setIsMandatoryRemarkForNAKPI,
  isMandatoryRemarkForNAKPI,
  setIsMandatoryRemarkForAllKPI,
  isMandatoryRemarkForAllKPI,
  setIsMandatoryGenericName,
  isMandatoryGenericName,
  setIsMandatoryFormRemark,
  isMandatoryFormRemark,
  isOpenRemarkModal,
  setIsOpenRemarkModal
}) => {

  const history = useHistory();

  useEffect(() => {
    fetchSystemSettings();
  }, [fetchSystemSettings]);

  useEffect(() => {
    fetchFormsTypes();
  }, []);

  useEffect(() => {
    if (form.asM_FormTypeID) {
      fetchFormTypeLines(form.asM_FormTypeID);
    }
  }, [form.asM_FormTypeID]);

  useEffect(() => {
    if(systemSettings.isMaintRemarkForFailKPI){
      const hasMissingRemark = Array.isArray(form.reportFormLines) &&
        form.reportFormLines.length > 0 &&
        form.reportFormLines.some((reportFormLine) => 
          reportFormLine.asM_ItemReportFormLineStatus === false &&
          (!reportFormLine.asM_ItemReportFormLineRemarks || reportFormLine.asM_ItemReportFormLineRemarks.trim() === "")
        );

      setIsMandatoryRemarkForFailKPI(hasMissingRemark);
    }
    
  }, [systemSettings, form, setIsMandatoryRemarkForFailKPI]);

  useEffect(() => {
    if(systemSettings.isMaintRemarkForNAKPI){
      const hasMissingRemark = Array.isArray(form.reportFormLines) &&
        form.reportFormLines.length > 0 &&
        form.reportFormLines.some((reportFormLine) => 
          reportFormLine.asM_ItemReportFormLineStatus === null &&
          (!reportFormLine.asM_ItemReportFormLineRemarks || reportFormLine.asM_ItemReportFormLineRemarks.trim() === "")
        );

      setIsMandatoryRemarkForNAKPI(hasMissingRemark);
    }
    
  }, [systemSettings, form, setIsMandatoryRemarkForNAKPI]);

  const chosenFormTypeObject = useMemo(() => {
    return formTypes.find(
      (item) => item.asM_FormTypeID === form.asM_FormTypeID
    );
  }, [form.asM_FormTypeID, formTypes]);

  useEffect(()=>{
    if (chosenFormTypeObject && chosenFormTypeObject.asM_FormTypeMustFillKPIRemarks){
      const hasMissingRemark = Array.isArray(form.reportFormLines) &&
        form.reportFormLines.length > 0 &&
        form.reportFormLines.some((reportFormLine) => 
          (reportFormLine.asM_ItemReportFormLineStatus === true || reportFormLine.asM_ItemReportFormLineStatus === false) &&
          (!reportFormLine.asM_ItemReportFormLineRemarks || reportFormLine.asM_ItemReportFormLineRemarks.trim() === "")
        );
        console.log('hasMissingRemark', hasMissingRemark);
        setIsMandatoryRemarkForAllKPI(hasMissingRemark);
    }
  }, [formTypes, form, setIsMandatoryRemarkForAllKPI, chosenFormTypeObject]);

  useEffect(()=>{
    if (chosenFormTypeObject &&
        (chosenFormTypeObject.asM_FormTypeMustFillKPIRemarks || chosenFormTypeObject.asM_FormTypeUseGenericName)){
      const hasMissingGenericName = (!form.asM_ItemReportFormGenericName || form.asM_ItemReportFormGenericName.trim() === "");
      setIsMandatoryGenericName(hasMissingGenericName);
    } else {
      setIsMandatoryGenericName(false)
    }
  }, [chosenFormTypeObject, form, setIsMandatoryGenericName]);


  useEffect(()=>{
    if((systemSettings.isMaintRemarkForFailure && form.asM_ItemReportOverallStatus === false) || 
      (chosenFormTypeObject && chosenFormTypeObject.asM_FormTypeMustFillKPIRemarks)){
      const hasMandatoryCommentMissing = (!form.asM_ItemReportFormRemarks || form.asM_ItemReportFormRemarks.trim() === "");
      setIsMandatoryFormRemark(hasMandatoryCommentMissing)
    } else {
      setIsMandatoryFormRemark(false)
    }
  },[systemSettings, form, chosenFormTypeObject, setIsMandatoryFormRemark])

  useEffect(() => {
    if (formTypeLines.length) {
      setForm((prev) => ({
        ...prev,
        reportFormLines: formTypeLines.map((lineItem) => ({
          asM_FormTypeID: form.asM_FormTypeID,
          asM_FormLineTypeID: lineItem.asM_FormLineTypeID,
          asM_FormtLineTypeName: lineItem.asM_FormtLineTypeName,
          asM_FormtLineTypeDesc: lineItem.asM_FormtLineTypeDesc,
          asM_ItemReportFormLineRemarks: lineItem.asM_ItemReportFormLineRemarks,
          ...(chosenFormTypeObject.asM_FormTypeIsRemarks && {
            asM_ItemReportFormLineText: "",
          }),
          ...(chosenFormTypeObject.asM_FormTypeIsStatus && {
            asM_ItemReportFormLineStatus: null,
          }),
          ...(chosenFormTypeObject.asM_FormTypeIsInOut && {
            asM_ItemReportFormLineInText: "",
            asM_ItemReportFormLineOutText: "",
          }),
        })),
      }));
    }
  }, [formTypeLines, chosenFormTypeObject]);

  useEffect(() => {
    if (chosenFormTypeObject) {
      setForm((prev) => ({
        ...prev,
        isFormTypeStatus: chosenFormTypeObject.asM_FormTypeIsStatus,
      }));
    }
  }, [chosenFormTypeObject]);

  useEffect(() => {
    fetchMaintAlertForFailKPI();
  }, [fetchMaintAlertForFailKPI]);

  const updateDateTime = (date) => {
    setForm((prev) => ({
      ...prev,
      asM_ItemReportFormDate: getDateTimeString(date),
    }));
  };

  const updateFormType = (formTypeId) => {
    setForm((prev) => ({
      ...prev,
      asM_FormTypeID: formTypeId,
    }));
  };

  const updateFormLineStatus = (formLineId, status) => {
    setForm((prev) => ({
      ...prev,
      reportFormLines: prev.reportFormLines.map((item) => {
        if (item.asM_FormLineTypeID === formLineId) {
          return {
            ...item,
            asM_ItemReportFormLineStatus: status,
          };
        }

        return item;
      }),
    }));
  };

  const updateFormLineInOutIn = (formLineId, value) => {
    setForm((prev) => ({
      ...prev,
      reportFormLines: prev.reportFormLines.map((item) => {
        if (item.asM_FormLineTypeID === formLineId) {
          return {
            ...item,
            asM_ItemReportFormLineInText: value,
          };
        }

        return item;
      }),
    }));
  };

  const updateFormLineInOutOut = (formLineId, value) => {
    setForm((prev) => ({
      ...prev,
      reportFormLines: prev.reportFormLines.map((item) => {
        if (item.asM_FormLineTypeID === formLineId) {
          return {
            ...item,
            asM_ItemReportFormLineOutText: value,
          };
        }

        return item;
      }),
    }));
  };

  const updateFormLineRemarks = (formLineId, value) =>{
    setForm((prev)=>({
      ...prev,
      reportFormLines : prev.reportFormLines.map((item)=>{
        if (item.asM_FormLineTypeID === formLineId) {
          return {
            ...item,
            asM_ItemReportFormLineRemarks: value,
          };
        }
        return item;
        
      })
    }))
  }

  const updateFormLineText = (formLineId, value) => {
    setForm((prev) => ({
      ...prev,
      reportFormLines: prev.reportFormLines.map((item) => {
        if (item.asM_FormLineTypeID === formLineId) {
          return {
            ...item,
            asM_ItemReportFormLineText: value,
          };
        }

        return item;
      }),
    }));
  };

  const updateFormRemarks = (value) => {
    setForm((prev) => ({
      ...prev,
      asM_ItemReportFormRemarks: value,
    }));
  };

  const updateFormStatus = (value) => {
    setForm((prev) => ({
      ...prev,
      asM_ItemReportOverallStatus: value,
    }));
  };

  const updateSendEmail = (value) => {
    setForm((prev) => ({
      ...prev,
      asM_ItemReportFormAlert: value,
    }));
  };
  const validation = useMemo(
    () => {
      const messages = [];
      if (!report.signatures.EmpSig) messages.push("Signature is required");
      if (!form.asM_ItemReportFormDate) messages.push("Date & Time should not be empty");
      if (!form.asM_FormTypeID) messages.push("Form Type should be selected");
      if (form.asM_ItemReportOverallStatus === null) messages.push("Please select Overall Status before submitting the form");
      if (isMandatoryRemarkForAllKPI) {
        messages.push("Remarks are required for all KPIs");
      } else {
        if (isMandatoryRemarkForFailKPI) {
          messages.push("Remarks are required for failed KPIs");
        }
        if (isMandatoryRemarkForNAKPI) {
          messages.push("Remarks are required for N/A KPIs");
        }
      }
      if (isMandatoryFormRemark) messages.push("Comments are required");
      if (isMandatoryGenericName) messages.push("Name should not be empty");

      return {
        ok: messages.length === 0,
        message: messages
      };
    },
    [report, form, isMandatoryRemarkForFailKPI, isMandatoryFormRemark, isMandatoryRemarkForAllKPI, isMandatoryGenericName, isMandatoryRemarkForNAKPI]
  );

  return (
    <Form error={!validation.ok}>
      <Card fluid>
      <Card.Content>
        <div style={{ display: "flex", alignItems: "flex-start", gap: "30px" }}>
          <FormField>
            <label>{locale.dateTime}</label>
            <ReactDatePicker
              name="DateTime"
              showTimeSelect
              dateFormat="dd/MM/yyyy HH:mm"
              selected={new Date(form.asM_ItemReportFormDate)}
              onChange={updateDateTime}
              timeFormat="HH:mm"
            />
          </FormField>
          {chosenFormTypeObject && 
            (chosenFormTypeObject.asM_FormTypeUseGenericName || chosenFormTypeObject.asM_FormTypeMustFillKPIRemarks) ? 
          <FormField>
            <label>
              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {locale.name}
                {(!form.asM_ItemReportFormGenericName || form.asM_ItemReportFormGenericName.trim() === "")
                  ? <ExclamationIcon />
                  : null
                }
              </div>
            </label>
            <Input
              type="text"
              name="Name"
              value={form.asM_ItemReportFormGenericName || ""}
              onChange={(e) => setForm({ ...form, asM_ItemReportFormGenericName: e.target.value })}
            />
          </FormField>: null}
        </div>
      </Card.Content>
      </Card>
      <Card fluid>
        <Card.Content>
          <Loader
            active={fetchingFormTypes}
            inline
            size="tiny"
            style={{ float: locale._meta.rtl ? "left" : "right" }}
          />
          <FormField>
            <label>{locale.formType}</label>
            <Select
              style={{ marginTop: "1rem" }}
              placeholder={locale.chooseFormType}
              options={formTypes.map((item) => ({
                key: item.asM_FormTypeID,
                value: item.asM_FormTypeID,
                text: item.asM_FormTypeName,
              }))}
              onChange={(e, { value }) => updateFormType(value)}
              value={form.asM_FormTypeID}
            />
          </FormField>
        </Card.Content>
      </Card>
      <Card fluid>
        <Card.Content>
          <Table celled sortable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell collapsing>K.P.I. name</Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  K.P.I. description
                </Table.HeaderCell>
                <Table.HeaderCell>Result</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {form.reportFormLines.map((reportFormLine, idx) => (
                <Table.Row
                  key={`reportFormLine-${idx}-${reportFormLine.asM_FormLineTypeID}`}
                  negative={reportFormLine.asM_ItemReportFormLineStatus === false}
                >
                  <Table.Cell collapsing>
                    {reportFormLine.asM_FormtLineTypeName}
                  </Table.Cell>
                  <Table.Cell collapsing>
                    {reportFormLine.asM_FormtLineTypeDesc}
                  </Table.Cell>
                  <Table.Cell>
                    <div style={{display:"flex", justifyContent:"space-between"}}>
                    {chosenFormTypeObject.asM_FormTypeIsRemarks && (
                      <FormField style={{ flex: "0.98" }}>
                        <label>Result</label>
                        <Input
                          placeholder="Result"
                          value={reportFormLine.asM_ItemReportFormLineText}
                          onChange={(e, { value }) =>
                            updateFormLineText(
                              reportFormLine.asM_FormLineTypeID,
                              value
                            )
                          }
                        />
                      </FormField>
                    )}
                    {chosenFormTypeObject.asM_FormTypeIsStatus && (
                      <ThreeStateInput
                        locale={locale}
                        value={reportFormLine.asM_ItemReportFormLineStatus}
                        onChange={(value) =>
                          updateFormLineStatus(
                            reportFormLine.asM_FormLineTypeID,
                            value
                          )
                        }
                        setIsOpenRemarkModal={setIsOpenRemarkModal}
                        chosenFormTypeObject={chosenFormTypeObject}
                        systemSettings={systemSettings}
                      />
                    )}
                   
                    {chosenFormTypeObject.asM_FormTypeIsInOut && (
                      <div style={{ display: "flex", gap: "1rem" }}>
                        <FormField>
                          <label>In</label>
                          <Input
                            placeholder="In"
                            value={reportFormLine.asM_ItemReportFormLineInText}
                            onChange={(e, { value }) =>
                              updateFormLineInOutIn(
                                reportFormLine.asM_FormLineTypeID,
                                value
                              )
                            }
                          />
                        </FormField>
                        <FormField>
                          <label>Out</label>
                          <Input
                            placeholder="Out"
                            value={reportFormLine.asM_ItemReportFormLineOutText}
                            onChange={(e, { value }) =>
                              updateFormLineInOutOut(
                                reportFormLine.asM_FormLineTypeID,
                                value
                              )
                            }
                          />
                        </FormField>
                      </div>
                    )}
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      {(systemSettings.isMaintRemarkForFailKPI) &&
                      form.isFormTypeStatus &&
                      reportFormLine.asM_ItemReportFormLineStatus === false &&
                      (reportFormLine.asM_ItemReportFormLineRemarks === undefined ||
                        reportFormLine.asM_ItemReportFormLineRemarks === "") ? (
                        <div style={{ marginTop: "7px" }}>
                          <ExclamationIcon />
                        </div>
                      ) : null}

                      {(systemSettings.isMaintRemarkForNAKPI) &&
                      form.isFormTypeStatus &&
                      reportFormLine.asM_ItemReportFormLineStatus === null &&
                      (reportFormLine.asM_ItemReportFormLineRemarks === undefined ||
                        reportFormLine.asM_ItemReportFormLineRemarks === "") ? (
                        <div style={{ marginTop: "7px" }}>
                          <ExclamationIcon />
                        </div>
                      ) : null}

                      {isMandatoryRemarkForAllKPI && 
                        reportFormLine.asM_ItemReportFormLineStatus === true &&
                        (reportFormLine.asM_ItemReportFormLineRemarks === undefined ||
                          reportFormLine.asM_ItemReportFormLineRemarks === "") ?
                      (
                        <div style={{ marginTop: "7px" }}>
                          <ExclamationIcon />
                        </div>
                      ) : null}

                      <FailedRemarkModal
                        report={report}
                        readOnly={false}
                        value={reportFormLine.asM_ItemReportFormLineRemarks || ""}
                        kpiResult={reportFormLine.asM_ItemReportFormLineStatus}
                        onChange={(value) =>
                          updateFormLineRemarks(reportFormLine.asM_FormLineTypeID, value)
                        }
                        clicked={isOpenRemarkModal}
                        isMandatoryRemarkForAllKPI={chosenFormTypeObject.asM_FormTypeMustFillKPIRemarks}
                      />
                    </div>

                  </div> 
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
            {!form.asM_FormTypeID && (
              <Table.Footer fullWidth>
                <Table.Row>
                  <Table.HeaderCell colSpan="3">
                    {locale.firstChooseFormType}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            )}
          </Table>
        </Card.Content>
      </Card>
      <Card fluid>
        <Card.Content>
          <FormField>
            <label>
              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {locale.comments}
                {((systemSettings.isMaintRemarkForFailure && form.asM_ItemReportOverallStatus === false) || 
                  (chosenFormTypeObject && chosenFormTypeObject.asM_FormTypeMustFillKPIRemarks)) && 
                  (!form.asM_ItemReportFormRemarks || form.asM_ItemReportFormRemarks.trim() === "") ?
                  <ExclamationIcon />:null}
              </div>
            </label>
            <TextArea
              name="comments"
              placeholder="Comments"
              onChange={(e, { value }) => updateFormRemarks(value)}
              value={form.asM_ItemReportFormRemarks}
            />
          </FormField>
        </Card.Content>
      </Card>
      <Card fluid>
        <Card.Content>
          <Form.Field>
            <label>{locale.overallStatus}</label>
            <OverallStatusButtonsContainer>
              <OverallStatusButton
                fluid
                rounded
                fail
                selected={form.asM_ItemReportOverallStatus === false}
                onClick={() => updateFormStatus(false)}
              >
                {locale.fail}
              </OverallStatusButton>
              <OverallStatusButton
                fluid
                rounded
                pass
                selected={form.asM_ItemReportOverallStatus === true}
                onClick={() => updateFormStatus(true)}
              >
                {locale.pass}
              </OverallStatusButton>
            </OverallStatusButtonsContainer>
          </Form.Field>
        </Card.Content>
      </Card>
      <Header>{locale.signature}</Header>
      <CardForSignature fluid>
        <div>
          <SignatureModal
            report={report}
            registerSignatrue={registerSignatrue}
            saveSignatrues={saveSignatrues}
            type="EmpSig"
            color="blue"
          />
        </div>
      </CardForSignature>
      <Checkbox
        label={locale.sendMail}
        style={{ marginBottom: "1rem" }}
        checked={form.asM_ItemReportFormAlert === true}
        onChange={(e, { checked }) => updateSendEmail(checked)}
      />
      <div>
        <Message
          error
          header={locale._system.validation.negative}
          list={validation.message}
        />
        <FormSubmitModal
          validation={validation}
          onSave={() => {
            history.push({ pathname: '/pending' });
          }}
          hasNoAnswers={hasNoAnswers}
          overallStatus={overallStatus}
          isFormTypeStatus={form.isFormTypeStatus}
          isMaintAlertForFailKPI={isMaintAlertForFailKPI}
          systemSettings={systemSettings}
          onSubmit={() => {
            onSubmit();
          }}
          onRequestExit={() => {
            window.location.href = `/forms/${form.asM_Item_ID}/records`;
          }}
          online={online}
        />
      </div>
    </Form>
  );
};

export default compose(
  hot(module),
  withReportSignatures,
  withState("fetchingFormTypes", "setFetchingFormTypes", false),
  withState("fetchingFormTypeLines", "setFetchingFormTypeLines", false),
  withState("formTypes", "setFormTypes", []),
  withState("formTypeLines", "setFormTypeLines", []),
  withState("isMaintAlertForFailKPI", "setIsMaintAlertForFailKPI", false),
  withState("systemSettings", "setSystemSettings", {}),
  withState("isMandatoryRemarkForFailKPI", "setIsMandatoryRemarkForFailKPI", false),
  withState("isMandatoryRemarkForNAKPI", "setIsMandatoryRemarkForNAKPI", false),
  withState("isMandatoryRemarkForAllKPI", "setIsMandatoryRemarkForAllKPI", false),
  withState("isMandatoryGenericName", "setIsMandatoryGenericName", false),
  withState("isMandatoryFormRemark", "setIsMandatoryFormRemark", false),
  withState("isOpenRemarkModal", "setIsOpenRemarkModal", false),
  withOnlineStatus,
  withAxios,
  withLocale("forms.form"),
  withHandlers({
    fetchFormsTypes:
      ({ setFetchingFormTypes, setFormTypes, axios }) =>
      async () => {
        setFetchingFormTypes(true);

        const { data } = await axios.get("/api/Forms/getFormsTypes");

        setFormTypes([...data]);
        setFetchingFormTypes(false);
      },
    fetchFormTypeLines:
      ({ setFetchingFormTypeLines, setFormTypeLines, axios }) =>
      async (formTypeId) => {
        setFetchingFormTypeLines(true);

        const { data } = await axios.get(
          `/api/Forms/getFormsLinesTypes?formTypeId=${formTypeId}`
        );

        setFormTypeLines([...data]);
        setFetchingFormTypeLines(false);
      },
    fetchSystemSettings:
      ({ setSystemSettings, axios }) =>
      async () => {
        try {
          const { data } = await axios.get('/api/common/terms');
          setSystemSettings(data);
        } catch (error) {
          console.error("Error fetching system settings:", error.message);
        }
      },
    fetchMaintAlertForFailKPI:
      ({ setIsMaintAlertForFailKPI, axios }) =>
      async () => {
        try {
          const { data } = await axios.get('/api/common/terms');
          setIsMaintAlertForFailKPI(data.isMaintAlertForFailKPI);
        } catch (error) {
          console.error("Error fetching isMaintAlertForFailKPI:", error.message);
        }
      },
  })
)(FormComponent);
